// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__j37TT","actions":"GroupTable_actions__3rQYl","deleteModalFooter":"GroupTable_deleteModalFooter__2KnpP"};